import { render } from "./GameGrid.vue?vue&type=template&id=4a68682a&scoped=true"
import script from "./GameGrid.vue?vue&type=script&lang=js"
export * from "./GameGrid.vue?vue&type=script&lang=js"

import "./GameGrid.vue?vue&type=style&index=0&id=4a68682a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4a68682a"

export default script